export const toOpenFBModalEvent = () => ({ event: 'Viewed Find Facebook Friends' });
